import React, { useEffect, useState } from "react";

interface GlassRevealOverlayProps {
  /** How long the blur takes to clear, in ms */
  duration?: number;
  /** Extra classes on the overlay (e.g. to constrain z-index) */
  className?: string;
}

// Drop as the last child of any `relative` container — covers it with an
// iOS-style frosted glass pane on mount, then clears to normal over `duration`.
const GlassRevealOverlay = ({ duration = 1500, className = "" }: GlassRevealOverlayProps) => {
  const [cleared, setCleared] = useState(false);

  useEffect(() => {
    // Paint the blurred state first, then kick off the clear transition
    const raf = requestAnimationFrame(() => setCleared(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 pointer-events-none z-40 ${className}`}
      style={{
        backdropFilter: cleared ? "blur(0px) saturate(100%)" : "blur(30px) saturate(180%)",
        WebkitBackdropFilter: cleared ? "blur(0px) saturate(100%)" : "blur(30px) saturate(180%)",
        backgroundColor: cleared ? "rgba(255,255,255,0)" : "rgba(255,255,255,0.45)",
        transition: `backdrop-filter ${duration}ms cubic-bezier(0.22,1,0.36,1), -webkit-backdrop-filter ${duration}ms cubic-bezier(0.22,1,0.36,1), background-color ${duration}ms cubic-bezier(0.22,1,0.36,1)`,
      }}
    />
  );
};

export default GlassRevealOverlay;
